import { ComponentRef, Injectable, ViewContainerRef } from "@angular/core";
import { RecaptchaComponent } from "../../components/recaptcha/recaptcha.component";
import { CertificatePreviewComponent } from "../../components/certificate-preview/certificate-preview/certificate-preview.component";
import { GoldIds, GOLDS } from "@soposopo/sopo-models/dist/shop/Golds";
import { ShopProductComponent } from "src/app/shop/component/product/product.component";
import { CustomSweepbuckMenuClass, SweepsbucksMenuComponent } from "../../components/sweepsbucks-menu/sweepsbucks-menu";
import { ResizeService } from "../resize/resize.service";
import { firstValueFrom } from "rxjs";
import { ShopAnimationPartToPlay } from "../purchase-animation/purchase-animation.service";
import { getAuth, RecaptchaVerifier } from "@angular/fire/auth";
import { SopoTransitionComponent } from "../../components/sopo-transition/sopo-transition.component";
import { SopoPopupService } from "src/app/sopo-popup/service/sopo-popup.service";
import { SopoAlertSettings } from "src/app/sopo-popup/interfaces/alert";
import { LoadingDispatcher } from "src/app/core/state/loading/loading.dispatcher";
import { AbstractLoginComponent } from "../../components/abstract-login/abstract-login.component";
import { ProfileSetupComponent } from "../../components/profile-setup/profile-setup.component";

export const DEFAULT_DISMISS_AFTER_TIME = 5000;
@Injectable({
    providedIn: 'root',
})
export class DynamicContentService {
    sweepbuckMenu: ViewContainerRef;
    purchaseProduct: ViewContainerRef;
    reCaptcha: ViewContainerRef;
    recaptchaVerifier: RecaptchaVerifier;
    recaptchaCompRef: ComponentRef<RecaptchaComponent>;

    certificatePreview: ViewContainerRef;
    certificatepreviewVerifier: RecaptchaVerifier;
    certificatepreviewhaCompRef: ComponentRef<RecaptchaComponent>

    sopoTransition: ViewContainerRef;

    abstractLogin: ViewContainerRef;
    profileSetup: ViewContainerRef;

    constructor(
        private resizeService: ResizeService,
        private sopoPopupService: SopoPopupService,
        private loadingService: LoadingDispatcher,
    ) { }

    init(reCaptcha: ViewContainerRef, certificatePreview: ViewContainerRef, sweepbuckMenu: ViewContainerRef, purchaseProductRef: ViewContainerRef, sopoTransition: ViewContainerRef, abstractLogin: ViewContainerRef, profileSetup: ViewContainerRef,) {
        this.sweepbuckMenu = sweepbuckMenu;
        this.purchaseProduct = purchaseProductRef;
        this.reCaptcha = reCaptcha;
        this.certificatePreview = certificatePreview;
        this.sopoTransition = sopoTransition;
        this.abstractLogin = abstractLogin;
        this.profileSetup = profileSetup;
    }

    initReCaptcha(){
        if (!this.recaptchaVerifier){
            this.recaptchaVerifier = new RecaptchaVerifier(
                getAuth(),
                'recaptcha-container-id',
                {
                    "size": "normal",
                    "callback": (response) => {
                        this.closeReCaptcha();
                    },
                    "expired-callback": () => {
                        this.closeReCaptcha();
                        this.loadingService.dismissLoading('auth');
                        this.showAlert('Recaptcha failed', 'Recapcha session expired, please try again.');
                        console.error('[DynamicContentService] - recaptcha expired callback');
                    },
                    "error-callback": () => {
                        this.closeReCaptcha();
                        this.loadingService.dismissLoading('auth');
                        this.showAlert('Recaptcha failed', 'Recapcha failed, please try again.');
                        console.error('[DynamicContentService] - recaptcha callback error');
                    }
            },
            );
        }
        this.recaptchaCompRef.location.nativeElement.setAttribute('style', 'z-index: 100000; display:flex;');
        return this.recaptchaVerifier;
    }

    openreCaptcha(elementId: string){
        if (this.reCaptcha) {
            this.reCaptcha.clear();
            this.recaptchaCompRef = this.reCaptcha.createComponent<RecaptchaComponent>(RecaptchaComponent);
            this.recaptchaCompRef.location.nativeElement.setAttribute('id', elementId);
        }
    }

    openSweepbuckMenu(divElement: HTMLElement, customClasses: CustomSweepbuckMenuClass[] = []) {
        const boundingClienRect = divElement.getBoundingClientRect();
        const headerHeight = document.getElementById('header').getBoundingClientRect().height;
        const top = `calc((${boundingClienRect.y}px + ${boundingClienRect.height}px + 1.2em) - ${headerHeight}px)`;
        const left = boundingClienRect.left;
        const right = window.innerWidth - boundingClienRect.right;

        if (this.sweepbuckMenu) {
            this.sweepbuckMenu.clear();
            const componentRef = this.sweepbuckMenu.createComponent<SweepsbucksMenuComponent>(SweepsbucksMenuComponent);
            if (divElement.id.includes('shop')) {
                componentRef.location.nativeElement.setAttribute('style',`position: absolute; padding-top: ${top}; padding-right: ${right}px; right: 0;`);
                customClasses.push('shop');
            }
            else componentRef.location.nativeElement.setAttribute('style',`position: absolute; padding-top: ${top}; padding-left: ${left}px`);
            componentRef.instance.customSweepBuckMenuClasses = customClasses;
        }
    }

    async openPurchaseProduct(productId: GoldIds, product: typeof GOLDS[GoldIds], animationToPlay: ShopAnimationPartToPlay) {
        if (this.purchaseProduct) {
            let fontSize = '0px';
            this.purchaseProduct.clear();
            const componentRef = this.purchaseProduct.createComponent<ShopProductComponent>(ShopProductComponent);
            componentRef.instance.productId = productId;
            componentRef.instance.product = product;
            componentRef.instance.animation = true;
            componentRef.location.nativeElement.setAttribute('id', `animation-product-${productId}`);
            fontSize = await firstValueFrom(this.resizeService.getCommonFontSize());
            componentRef.location.nativeElement.setAttribute('style', `position: absolute; z-index: -1; opacity: 0; border: 4px solid white; border-radius: 7px; font-size: ${fontSize}; max-width: 10em; max-height: 10em; top: 45%; left: 50%; transform: translate(-50%, -50%) scale(0); pointer-events: none;`);
        }
    }

    openTransition() {
        if (this.sopoTransition) {
            const componentRef = this.sopoTransition.createComponent<SopoTransitionComponent>(SopoTransitionComponent);
            (componentRef.location.nativeElement as HTMLElement).setAttribute('style', 'z-index: 2000;');
            return componentRef;
        }
    }

    openAbstractLogin(url: string) {
        if (this.abstractLogin) {
            const componentRef = this.abstractLogin.createComponent<AbstractLoginComponent>(AbstractLoginComponent);
            componentRef.instance.initIframe(url);
            this.sopoPopupService.setAbstractWalletOpened(true);
            return componentRef;
        }
    }

    openProfileSetup() {
        if (this.profileSetup) {
            this.profileSetup.clear()
            this.profileSetup.createComponent<ProfileSetupComponent>(ProfileSetupComponent);
        }
    }

    closeAbstractLogin() {
        this.abstractLogin.clear();
        this.sopoPopupService.setAbstractWalletOpened(false);
    }

    closeReCaptcha() {
        (this.recaptchaCompRef.location.nativeElement as HTMLElement).removeAttribute("style");
    }

    openCertificatePreview(){
        if (this.certificatePreview) {
            this.certificatePreview.clear();
            this.certificatepreviewhaCompRef = this.certificatePreview.createComponent<CertificatePreviewComponent>(CertificatePreviewComponent);
        }
    }

    closeCertificatePreview() {
        this.certificatePreview.clear();
    }

    closePurchaseProduct() {
        this.purchaseProduct.clear();
    }

    closeSweepbuckMenu() {
        this.sweepbuckMenu.clear();
    }

    closeSopoTransition() {
        this.sopoTransition.clear();
    }

    closeProfileSetup() {
        this.profileSetup.clear();
    }

    private async showAlert(header: string, message: string, dismissAfter = DEFAULT_DISMISS_AFTER_TIME) {
        this.sopoPopupService.clearViewContainer('app');
        const sopoAlertSettings: SopoAlertSettings = {
            header,
            message,
            dismissAfter,
        };
        await this.sopoPopupService.showAlert('app', sopoAlertSettings);
    }
}
